import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import SurplusMaterialsTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import surplusIcon from "../../../../../assets/new-product-detail-cats/sub-icons/surplus-material-flows.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const SurplusMaterials = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_MATERIALS_TRANSPORT") || "Surplus Materials Generated in Transportation"}
        subDescription={t("SURPLUS_MATERIALS_TRANSPORT_DESC") || "Materials and resources generated as surplus during transportation."}
        isNormal={true}
        number={"32.2"}
        icon={surplusIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-materials-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusMaterialsTable productId={productId} />
        </TableLoadingWrapper>
      )}

      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default SurplusMaterials;

